module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form container"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Edit entry")]), _vm._v(" "), _c('div', {
    staticClass: "form-article formResponsive formHorizontal"
  }, [(!_vm.showForm) ? _c('div', {
    staticClass: "formCover"
  }) : _vm._e(), _vm._v(" "), (!_vm.entry.lexical) ? _c('div', {
    staticClass: "form-article-item article"
  }, [_c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Article")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n          Term: " + _vm._s(_vm.article.name_language) + "\n        ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.title),
      expression: "article.title"
    }],
    attrs: {
      "type": "text",
      "name": ""
    },
    domProps: {
      "value": (_vm.article.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.article.body),
      callback: function($$v) {
        _vm.$set(_vm.article, "body", $$v)
      },
      expression: "article.body"
    }
  }), _vm._v(" "), _c('br')], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Illustrations")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Optional (Maximum 1 image)")]), _vm._v(" "), _c('input', {
    staticClass: "imageinput",
    attrs: {
      "type": "file"
    },
    on: {
      "change": _vm.uploadImage
    }
  }), _vm._v(" "), _c('p', [_vm._v("Pictures (Photos, Drawings, etc). Allowed files: .jpg .png .gif")]), _vm._v(" "), (_vm.article.img_url) ? _c('div', {
    staticClass: "image-consent"
  }, [_c('label', {
    staticClass: "container2 inline",
    attrs: {
      "for": "expressconsent0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.img_auth),
      expression: "article.img_auth"
    }],
    staticClass: "rsform-checkbox",
    attrs: {
      "type": "checkbox",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.article.img_auth) ? _vm._i(_vm.article.img_auth, "true") > -1 : (_vm.article.img_auth)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.article.img_auth,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.article, "img_auth", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.article, "img_auth", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.article, "img_auth", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "checkmark"
  })]), _vm._v(" "), _c('p', {
    staticClass: "inline"
  }, [_vm._v("\n            The user declares that the submitted content has a Creative Commons License or is\n            covered by copyright to which they have a valid license.\n          ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Keywords")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Please write your keywords in english (maximum 3).")]), _vm._v(" "), _c('div', {
    staticClass: "rsform-block"
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.keyword1),
      expression: "article.keyword1"
    }],
    staticClass: "rsform-input-box",
    attrs: {
      "type": "text",
      "value": "",
      "size": "20",
      "placeholder": "1."
    },
    domProps: {
      "value": (_vm.article.keyword1)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "keyword1", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "formDescription"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rsform-block"
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.keyword2),
      expression: "article.keyword2"
    }],
    staticClass: "rsform-input-box",
    attrs: {
      "type": "text",
      "value": "",
      "size": "20",
      "placeholder": "2."
    },
    domProps: {
      "value": (_vm.article.keyword2)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "keyword2", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "formDescription"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "rsform-block"
  }, [_c('div', {
    staticClass: "formControls"
  }, [_c('div', {
    staticClass: "formBody"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.keyword3),
      expression: "article.keyword3"
    }],
    staticClass: "rsform-input-box",
    attrs: {
      "type": "text",
      "value": "",
      "size": "20",
      "placeholder": "3."
    },
    domProps: {
      "value": (_vm.article.keyword3)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article, "keyword3", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "formDescription"
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Hyperlinks")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Choose a maximum of 3 hyperlinks to other terms.")]), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("All Terms (A-Z)")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.currentLink),
      expression: "article.currentLink"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.article, "currentLink", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "label": "Choose a Term"
    }
  }), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Epistemologies"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 1) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "History and Genealogy"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 2) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Cultural Practices and Performativities"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 3) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Linguistic Uses"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 4) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0), _vm._v(" "), _c('optgroup', {
    attrs: {
      "label": "Arts, Literatures and imaginaries"
    }
  }, _vm._l((_vm.apiTerms), function(term) {
    return (term.section_id === 5) ? _c('option', {
      domProps: {
        "value": term.id
      }
    }, [_vm._v(_vm._s(term.term_english))]) : _vm._e()
  }), 0)]), _vm._v(" "), _c('button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.addLink(_vm.article.currentLink)
      }
    }
  }, [_vm._v("Add")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('ul', [_vm._l((_vm.article.linkList), function(link) {
    return _c('li', _vm._l((_vm.apiTerms), function(term) {
      return (term.id === link) ? _c('span', [_vm._v("\n              " + _vm._s(term.term_english) + " -\n              "), _c('button', {
        attrs: {
          "type": "button"
        },
        on: {
          "click": function($event) {
            return _vm.removeLink(_vm.article.currentLink)
          }
        }
      }, [_vm._v("Remove")])]) : _vm._e()
    }), 0)
  }), _vm._v(" "), (_vm.article.linkValidation) ? _c('p', [_vm._v("Maximum 3 Links")]) : _vm._e()], 2), _vm._v(" "), _c('br')]), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Bibliographic References")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('wysiwyg', {
    model: {
      value: (_vm.article.references),
      callback: function($$v) {
        _vm.$set(_vm.article, "references", $$v)
      },
      expression: "article.references"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("Include 3 to 5 bibliographic references within a maximum of 1000 characters (total).")]), _vm._v(" "), _c('p', [_vm._v("The references must follow the Publication Guidelines.")])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-article-item"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("Author")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("Name")]), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.surname),
      expression: "article.author.surname"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "placeholder": "Surname"
    },
    domProps: {
      "value": (_vm.article.author.surname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.author, "surname", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.firstName),
      expression: "article.author.firstName"
    }],
    staticClass: "inline",
    attrs: {
      "type": "text",
      "placeholder": "First name and middle name"
    },
    domProps: {
      "value": (_vm.article.author.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.author, "firstName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "tit2"
  }, [_vm._v("Affiliation and Funding Reference")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.article.author.affiliation),
      expression: "article.author.affiliation"
    }],
    domProps: {
      "value": (_vm.article.author.affiliation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.article.author, "affiliation", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('p', [_vm._v("Max 300 characters")])])]) : _vm._e(), _vm._v(" "), _c('input', {
    attrs: {
      "value": "Submit",
      "type": "submit",
      "name": ""
    },
    on: {
      "click": function($event) {
        return _vm.validateArticle()
      }
    }
  }), _vm._v(" "), (_vm.$store.state.auth.role === 'author') ? _c('input', {
    attrs: {
      "value": "Delete",
      "type": "submit",
      "name": ""
    },
    on: {
      "click": function($event) {
        return _vm.deleteArticle()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticClass: "validation"
  }, [_vm._v(_vm._s(_vm.validation))])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n          Title\n          "), _c('p', [_vm._v("(optional)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7ed3e0d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditPage.vue
// module id = 169
// module chunks = 2